module.exports = __webpack_public_path__ + "img/phone.44e6d845.svg";